import React from 'react';
import styled from 'styled-components';
import TextComponent from '../TextComponent';

interface Props {
  children?: React.ReactNode;
  center?: boolean;
}

const Card: React.FC<Props> = ({ children, center = false }) => {
  return <Wrapper center={center}>{children}</Wrapper>;
};

const Wrapper = styled.div<{ center: boolean }>`
  ${({ center }) =>
    center &&
    `
    display: flex;
    justify-content: center;
  `}
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI17R};
  color: ${({ theme, color }) => (!!color ? color : theme.DF_COLOR.GRAY900)};
`;

export const CardTitle = styled(TextComponent)`
  margin-bottom: 17px;
  font-size: 20px;
  font-weight: 700;
  color: #000;
`;

export default Card;
